import * as React from 'react';
import * as moment from 'moment';
import * as queryString from 'query-string';
import { Props } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { connect, Dispatch } from 'react-redux';
import { Moment } from 'moment';

import { Spiner } from '../../../Shared/Spiner/Spiner';

import { AppState } from '../../../../reducers';

import { setCurrencyAction } from '../../../../actions/Hotels/currencies';
import {
    setCheckinAction,
    setCheckoutAction,
    setAdultsAction,
    setChildrenAction,
    setHotelIDAction,
    setRegionIDAction,
    setChildrensAction,
    getHotelInfoAction
} from '../../../../actions/Hotels/hotels';

import { Hotel } from '../../../../models/Hotels/Hotel';
import { Currency } from '../../../../models/Hotels/Currency';

import { HotelPoliciesView } from './HotelPoliciesView';
import {
    setChannelIdAction,
    setTariffIdAction,
    setUserIdAction,
    setUserLangAction
} from '../../../../actions/user';
import { HomeButtonView } from '../../../Buttons/HomeButton/HomeButtonView';
import { checkChannelId, checkTariffId, checkUserId } from '../../../../lib/utils';
import { getProfileInfo } from '../../../../actions/profile';
import i18next from 'i18next';

interface RouteProps extends RouteComponentProps<{}> {
    match: any;
    history: any;
}

interface HotelPoliciesContainerProps extends Props<HotelPoliciesContainer> {
    hotel: Hotel | null;

    checkin: Moment | null;
    checkout: Moment | null;
    adults: number;
    children: number;
    childrens: number[];
    hotelID: string | null;
    regionID: string | null;
    currency: Currency;

    userId: string;
    channelId: string;
    lang: string;
    tariffId: number;

    loadingHotelInfo: boolean;
    errorHotelInfo: any;
}

interface HotelPoliciesContainerDispatch extends Props<HotelPoliciesContainer> {
    setCheckin: (date: Moment) => any;
    setCheckout: (date: Moment) => any;
    setAdults: (adults: number) => any;
    setChildren: (children: number) => any;
    setHotelID: (hotelID: string) => any;
    setRegionID: (regionID: string) => any;
    setCurrency: (currency: Currency) => any;
    setChildrens: (childrens: number[]) => any;
    getProfile: (userId: string) => any;
    setUserId: (id: string) => any;
    setTariffId: (tariffId: number) => any;
    setLang: (lang: string) => any;
    setChannelId: (channelId: string) => any;
    getHotelInfo: (hotelID: string, lang: string) => any;
}

function mapProps(state: AppState, props: HotelPoliciesContainerProps): HotelPoliciesContainerProps {
    return {
        hotel: state.hotelsState.hotel,

        checkin: state.hotelsState.checkin,
        checkout: state.hotelsState.checkout,
        adults: state.hotelsState.adults,
        children: state.hotelsState.children,
        hotelID: state.hotelsState.hotelID,
        regionID: state.hotelsState.regionID,
        currency: state.hotelsCurrencyState.currency,
        childrens: state.hotelsState.childrens,

        userId: state.userState.userId,
        channelId: state.userState.channelId,
        lang: state.userState.lang,
        tariffId: state.userState.tariffId,

        loadingHotelInfo: state.hotelsState.loadingHotelInfo,
        errorHotelInfo: state.hotelsState.errorHotelInfo
    };
}

function mapDispatch(dispatch: Dispatch<any>): HotelPoliciesContainerDispatch {
    return {
        setCheckin: (date: Moment) => dispatch(setCheckinAction(date)),
        setCheckout: (date: Moment) => dispatch(setCheckoutAction(date)),
        setAdults: (adults: number) => dispatch(setAdultsAction(adults)),
        setChildren: (children: number) => dispatch(setChildrenAction(children)),
        setHotelID: (hotelID: string) => dispatch(setHotelIDAction(hotelID)),
        setRegionID: (regionID: string) => dispatch(setRegionIDAction(regionID)),
        setCurrency: (currency: Currency) => dispatch(setCurrencyAction(currency)),
        setChildrens: (childrens: number[]) => dispatch(setChildrensAction(childrens)),
        setUserId: (id: string) => dispatch(setUserIdAction(id)),
        setTariffId: (tariffId) => dispatch(setTariffIdAction(tariffId)),
        setChannelId: (channelId) => dispatch(setChannelIdAction(channelId)),
        getProfile: (userId: string) => dispatch(getProfileInfo(userId)),
        setLang: (lang: string) => dispatch(setUserLangAction(lang)),
        getHotelInfo: (hotelID: string, lang: string) => dispatch(getHotelInfoAction(hotelID, lang)),
    };
}

interface HotelPoliciesContainerState {
    fromApp: boolean;
}

type AllProps = HotelPoliciesContainerProps & HotelPoliciesContainerDispatch & RouteProps;

class HotelPoliciesContainer extends React.Component<AllProps, HotelPoliciesContainerState> {
    state = {
        fromApp: false
    };

    constructor(props: AllProps) {
        super(props);
        window.scrollTo(0, 0);
    }

    componentWillReceiveProps(nextProps: Readonly<AllProps>, nextContext: any) {
        if (!queryString.parse(nextProps.history.location.search).user_id) {
            this.setState({fromApp: true});
        }
    }

    processUrlParams = () => {
        const {history, setCheckin, setCheckout, lang, tariffId, setAdults, setChildren, setHotelID, setRegionID, setCurrency, setChildrens} = this.props;
        const userId = localStorage.KON_USER_ID;
        const channelId = localStorage.KON_CHANNEL_ID;
        if (history.location.search) {
            const params = queryString.parse(history.location.search);
            const checkin = moment(params.checkin, 'YYYY-MM-DD');
            const checkout = moment(params.checkout, 'YYYY-MM-DD');
            const currencyID = params.currency_id;
            const currrencyName = params.currency_name;
            const currencyCode = params.currency_code;
            const adults = Number(params.adults);
            const children = Number(params.children);
            const childrens = params.childrens && params.childrens.split(',');
            const hotelID = params.id;
            const regionID = params.region_id;
            if (childrens && (!this.props.childrens || childrens.length !== this.props.childrens.length)) {
                setChildrens(childrens.map((c: string) => Number(c)));
            }
            if (checkin.isValid() && (!this.props.checkin || !checkin.isSame(this.props.checkin))) {
                setCheckin(checkin);
            }
            if (checkout.isValid() && (!this.props.checkout || !checkout.isSame(this.props.checkout))) {
                setCheckout(checkout);
            }
            if (currencyID && currrencyName && currencyCode && (!this.props.currency.code || this.props.currency.code !== currencyCode)) {
                setCurrency({
                    id: params.currency_id,
                    name: params.currency_name,
                    code: params.currency_code
                });
            }
            if (adults && (!this.props.adults || this.props.adults !== adults)) {
                setAdults(adults);
            }
            if (!isNaN(children) && children && (!this.props.children || this.props.children !== children)) {
                setChildren(children);
            }
            if (hotelID && (!this.props.hotelID || this.props.hotelID !== hotelID)) {
                setHotelID(hotelID);
            }
            if (regionID && (!this.props.regionID || this.props.regionID !== regionID)) {
                setRegionID(regionID);
            }
            return params;
        } else {
            history.push(`/hotels/search?user_id=${userId}&channel_id=${channelId}&lang=${lang}&tariff_id=${tariffId}`);
            return null;
        }
    }

    async componentDidMount() {
        const {history, channelId, setChannelId, tariffId, setLang, getHotelInfo, setTariffId, hotel, lang} = this.props;
        if (queryString.parse(history.location.search).user_id) {
            if (history.location.search) {
                const params = this.processUrlParams();
                const param = queryString.parse(history.location.search);
                const user_id = await checkUserId(param.user_id, this.props.userId,
                    () => this.props.history.push(`/authorization?channel_id=${localStorage.KON_CHANNEL_ID}&phone=${localStorage.phone}&user_id=${localStorage.channelUserId}&lang=${localStorage.KON_LANG}`),
                    this.props.getProfile, this.props.setUserId);
                const tariff_id = checkTariffId(tariffId, setTariffId);
                const language = params.lang;
                if (!params || !params.id) {
                    history.push(`/hotels/search?user_id=${user_id}&channel_id=${checkChannelId(channelId, setChannelId)}&lang=${language || lang}&tariff_id=${tariff_id}`);
                }
                if (!lang) {
                    setLang(language || 'ru');
                }
                if (language && language !== lang && i18next.languages.some(it => it === lang)) {
                    setLang(language);
                    await i18next.changeLanguage(language);
                }
            }
        }
        if (!hotel) {
            const params = queryString.parse(history.location.search);
            if (params.id && params.lang) {
                getHotelInfo(params.id, params.lang);
            } else {
                alert(i18next.t('error_contact_konsierge'));
            }
        }
    }

    render() {
        const { errorHotelInfo, loadingHotelInfo, hotel, history, userId, children,
            childrens, currency, checkout, checkin, hotelID, adults, lang } = this.props;
        const {fromApp} = this.state;
        document.title = i18next.t('hotel_policies');
        if (loadingHotelInfo) {
            return <Spiner />;
        } else {
            return (
                <div className='container'>
                    {!fromApp && <HomeButtonView
                        clickHome={() => history.push(`/services?user_id=${encodeURIComponent(localStorage.KON_USER_ID)}&channel_id=${localStorage.KON_CHANNEL_ID}&lang=${localStorage.KON_LANG}&tariff_id=${localStorage.KON_TARIFF_ID}`)}
                        back={true}
                        clickBack={() => history.push(`/hotels/search-actual-rates?mode=hotel&user_id=${userId}&id=${hotelID}` +
                            `&checkin=${checkin!.format('YYYY-MM-DD')}&checkout=${checkout!.format('YYYY-MM-DD')}&adults=${adults}${children && childrens ? `&children=${children}&childrens=${childrens.join(',')}` : ''}` +
                            `&currency_id=${currency.id}&currency_name=${currency.name}&currency_code=${currency.code}${queryString.parse(history.location.search).residency ? '&residency=' + queryString.parse(history.location.search).residency : ''}&lang=${lang}`)}
                    />}
                    {!errorHotelInfo ?
                        hotel && <HotelPoliciesView
                            hotel={hotel}
                        />
                        : alert(i18next.t('error_contact_konsierge'))}
                </div>
            );
        }
    }
}

export default withRouter(connect(mapProps, mapDispatch)(HotelPoliciesContainer));



// WEBPACK FOOTER //
// ./src/components/Hotels/Hotel/HotelPolicies/HotelPoliciesContainer.tsx